export default __webpack_public_path__ + "static/as-5d327c21e6b7c258c265573857bbb4df.jpeg";